import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Loading2Component } from './loading2/loading2.component';
import { ReactiveFormsModule } from '@angular/forms';
import {
  MatButtonModule,
  MatInputModule,
  MatRippleModule,
  MatFormFieldModule,
  MatTooltipModule,
  MatSelectModule,
  MatSortModule,
  MatTableModule,
  MatDatepickerModule,
  MatRadioModule,
  MatCheckboxModule,
  MatTabsModule,

} from '@angular/material';
import { Error1Component } from './error1/error1.component';
import { ProgressComponent } from './progress/progress.component';

@NgModule({
  declarations: [ Loading2Component,Error1Component, ProgressComponent],
  imports: [MatButtonModule,
    MatInputModule,
    MatRippleModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatTabsModule,
    CommonModule,
    ReactiveFormsModule,
  ],
  exports: [MatButtonModule,
    MatInputModule,
    MatRippleModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatSelectModule,
    MatSortModule,
    MatTableModule,
    MatDatepickerModule,
    MatRadioModule,
    MatTabsModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    Loading2Component,
    Error1Component,
    ProgressComponent
]

})
export class SharedModule { }
